"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var _decorators = require("decorators");

var PersonColumnContainerBlock =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(PersonColumnContainerBlock, _BlockContainer);

  function PersonColumnContainerBlock() {
    babelHelpers.classCallCheck(this, PersonColumnContainerBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PersonColumnContainerBlock).apply(this, arguments));
  }

  return PersonColumnContainerBlock;
}(_base.BlockContainer);

exports.default = PersonColumnContainerBlock;